import React, { Component } from 'react';
import { registrationSuccess } from '../actions';

class RegistrationSuccess extends Component {
  componentWillMount() {
    if (window.parent.store) {
      window.parent.store.dispatch(registrationSuccess());
    }
  }

  render() {
    return (<div />);
  }
}

export default RegistrationSuccess;
